module.exports = __webpack_public_path__ + "img/stopwatch-solid-icon.f939d7da.svg";